import {
  AppBar,
  Card,
  CardContent,
  Fab,
  Icon,
  IconButton,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core';
import {
  fetchLiveBookings,
  moveLiveBooking,
  refundBooking,
  updateLocalLiveBookings,
} from 'actions/booking';
import { showAlert } from 'actions/client';
import ConfirmationDialog from 'components/Utility/Dialogs/ConfirmationDialog';
import NotifySnackbar from 'components/Utility/Snackbars/NotifySnackbar';
import moment from 'moment';
import React, { useState } from 'react';
import Loader from 'react-overlay-loader/lib/Loader';
import Pusher from 'react-pusher';
import { connect } from 'react-redux';
import { useSwipeable } from 'react-swipeable';
import {
  EditLiveBookingAPIRequest,
  GetBookingsAPIRequest,
  PrintBookingAPIRequest,
} from 'utils/constants/network';
import {
  accentForCurrency,
  multiplyValueForCurrency,
} from 'utils/currency/currency-utils';
import CompleteOrderIcon from 'utils/images/complete-order.svg';
import RefundIcon from 'utils/images/refund.svg';
import { callAPI } from 'utils/network';
import beep from 'utils/sounds/beep.mp3';
import AlertDialog from '../../../Utility/Dialogs/AlertDialog';
import './index.scss';

const renderPrepAreaLabel = label => {
  if (label === 'general') {
    return 'Front of House';
  } else return label.charAt(0).toUpperCase() + label.slice(1);
};

const renderPrepAreaLabelStatus = status => {
  switch (status) {
    case 'InProgress':
      return 'In Progress';
    case 'Completed':
      return 'Waiting';
    case 'Archived':
      return 'Completed';
    default:
      return status;
  }
};

const getBookingIcon = booking => {
  if (booking.service_type === 'collection') {
    if (booking.collection_time) {
      return 'schedule';
    }

    return 'directions_walk';
  }

  if (booking.service_type === 'table') {
    return 'event_seat';
  }

  return 'event_seat';
};

const getBookingTypeLabel = booking => {
  if (booking.service_type === 'collection') {
    if (booking.collection_time) {
      return `Collection at <strong>${moment(booking.collection_time).format(
        'HH:mm'
      )}</strong>`;
    }
    return 'Collection';
  }

  if (booking.service_type === 'table') {
    return `Table ${booking.table}`;
  }

  if (booking.service_type === 'dropoff') {
    return 'Drop off';
  }

  return 'Unknown';
};

const PreorderList = ({
  preorders,
  movePreorder,
  onRefundBooking,
  printingEnabled,
  isPrinting,
  printBooking,
}) => {
  if (!preorders || preorders.length === 0) {
    return <h3>No Preorders Yet!</h3>;
  }
  return preorders.map(booking => {
    return (
      <Card key={booking.id} className="booking__card booking__card__preorder">
        <IconButton
          onClick={() => movePreorder(booking)}
          className="move__booking__icon"
        >
          <Icon>double_arrow</Icon>
        </IconButton>
        <IconButton
          onClick={() => onRefundBooking(booking)}
          className="refund__button"
        >
          <img alt="" style={{ width: 22, height: 19 }} src={RefundIcon} />
        </IconButton>
        <CardContent className="booking__card__content">
          <Typography
            style={{ padding: 16, paddingBottom: 0 }}
            className="booking__card__icon"
            color="primary"
          >
            <Icon>{getBookingIcon(booking)}</Icon>
          </Typography>
          <Typography
            style={{ padding: '0px 16px' }}
            className="booking__card__type"
            color="primary"
            gutterBottom
          >
            <span
              dangerouslySetInnerHTML={{ __html: getBookingTypeLabel(booking) }}
            />
          </Typography>
          <Typography
            style={{ padding: '0px 16px' }}
            className="order__name"
            color="secondary"
          >
            {booking.name}
          </Typography>
          <Typography
            style={{ padding: '0px 16px' }}
            className="order__notes"
            color="textSecondary"
          >
            {booking.notes}
          </Typography>
          <div className="order__seperator" />
          <div className="order__container">
            {booking.order_items.map(product => {
              return (
                <React.Fragment key={product.id || product.name}>
                  <div>
                    <span className="order__container__item__quantity">
                      {product.quantity} x
                    </span>{' '}
                    <span className="order__container__item__name">
                      {product.name}
                    </span>
                  </div>
                  {(product.children || []).map(variant => (
                    <div className="order__container__item__variant">
                      <span className="order__container__item__quantity">
                        + {variant.quantity > 1 ? variant.quantity : ''}
                      </span>{' '}
                      <span className="order__container__item__name">
                        {variant.name}
                      </span>
                    </div>
                  ))}
                </React.Fragment>
              );
            })}
          </div>

          {printingEnabled && (
            <div>
              <IconButton
                disabled={isPrinting}
                className="printer__icon"
                onClick={() => printBooking(booking.id)}
              >
                <Icon>printer</Icon>
              </IconButton>
            </div>
          )}
        </CardContent>
      </Card>
    );
  });
};

const OrderList = ({
  bookings,
  moveLiveBooking,
  onRefundBooking,
  prepArea,
  printingEnabled,
  printBooking,
  isPrinting,
}) => {
  if (!bookings) {
    return [];
  }

  return bookings.map(booking => {
    let bookingPrepAreas = [];

    for (const [key] of Object.entries(booking.live_prep_area_status)) {
      if (key !== prepArea) {
        bookingPrepAreas.push(key);
      }
    }

    return (
      <Card key={booking.id} className="booking__card">
        <IconButton
          onClick={() => moveLiveBooking(booking)}
          className="move__booking__icon"
        >
          {booking.live_prep_area_status[prepArea] !== 'Completed' && (
            <Icon>double_arrow</Icon>
          )}
          {booking.live_prep_area_status[prepArea] === 'Completed' && (
            <img
              alt=""
              style={{ width: 17, height: 22 }}
              src={CompleteOrderIcon}
            />
          )}
        </IconButton>
        <IconButton
          onClick={() => onRefundBooking(booking)}
          className="refund__button"
        >
          <img alt="" style={{ width: 22, height: 19 }} src={RefundIcon} />
        </IconButton>
        <CardContent className="booking__card__content">
          <Typography
            style={{ padding: 16, paddingBottom: 0 }}
            className="booking__card__icon"
            color="primary"
          >
            <Icon>{getBookingIcon(booking)}</Icon>
          </Typography>
          <Typography
            style={{ padding: '0px 16px' }}
            className="booking__card__type"
            color="primary"
            gutterBottom
          >
            <span
              dangerouslySetInnerHTML={{ __html: getBookingTypeLabel(booking) }}
            />
          </Typography>
          {booking.client_id && (
            <div className="order__client__container">
              <span className="order__client__name">{booking.client_name}</span>
            </div>
          )}
          <Typography
            style={{ padding: '0px 16px' }}
            className="order__name"
            color="secondary"
          >
            {booking.name}
          </Typography>
          <Typography
            style={{ padding: '0px 16px' }}
            className="order__notes"
            color="textSecondary"
          >
            {booking.notes}
          </Typography>
          <div className="order__seperator" />
          <div className="order__container">
            {booking.order_items.map(product => {
              return (
                <React.Fragment key={product.id || product.name}>
                  <div>
                    <span className="order__container__item__quantity">
                      {product.quantity} x
                    </span>{' '}
                    <span className="order__container__item__name">
                      {product.name}
                    </span>
                  </div>
                  {(product.children || []).map(variant => (
                    <div className="order__container__item__variant">
                      <span className="order__container__item__quantity">
                        + {variant.quantity > 1 ? variant.quantity : ''}
                      </span>{' '}
                      <span className="order__container__item__name">
                        {variant.name}
                      </span>
                    </div>
                  ))}
                </React.Fragment>
              );
            })}
          </div>
          {bookingPrepAreas.length > 0 &&
            bookingPrepAreas.map(prepLabel => (
              <div key={booking.id + prepLabel} className="preparea__container">
                <span className="preparea__includes">
                  Includes {renderPrepAreaLabel(prepLabel)} Order
                </span>
                <span className="preparea__status">
                  {renderPrepAreaLabelStatus(
                    booking.live_prep_area_status[prepLabel]
                  )}
                </span>
              </div>
            ))}
          {printingEnabled && (
            <div>
              <IconButton
                disabled={isPrinting}
                className="printer__icon"
                onClick={() => printBooking(booking.id)}
              >
                <Icon>printer</Icon>
              </IconButton>
            </div>
          )}
        </CardContent>
      </Card>
    );
  });
};

const CompactScreenContainer = ({ neworders, inprogress, completed }) => {
  const [tabVal, setTabVal] = useState(0);

  const numTabs = 3;

  const handlers = useSwipeable({
    onSwipedLeft: () => setTabVal(tabVal < numTabs - 1 ? tabVal + 1 : tabVal),
    onSwipedRight: () => setTabVal(tabVal > 0 ? tabVal - 1 : tabVal),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  return (
    <div className="compact__container">
      <AppBar style={{ boxShadow: 'none' }} position="static" color="default">
        <Tabs
          className="tab__bar"
          value={tabVal}
          onChange={(e, val) => setTabVal(val)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="New" />
          <Tab label="In Progress" />
          <Tab label="Waiting" />
        </Tabs>
      </AppBar>
      <div {...handlers} className="swipe__container">
        {tabVal === 0 && <div className="compact__column">{neworders}</div>}
        {tabVal === 1 && <div className="compact__column">{inprogress}</div>}
        {tabVal === 2 && <div className="compact__column">{completed}</div>}
      </div>
    </div>
  );
};

const WideScreenContainer = ({ neworders, inprogress, completed }) => {
  return (
    <div className="wide__columns__container">
      <div className="wide__column">
        <Typography
          className="wide__column__header"
          component="h3"
          color="primary"
          gutterBottom
        >
          New
        </Typography>
        {neworders}
      </div>
      <div className="wide__column">
        <Typography
          className="wide__column__header"
          component="h3"
          color="primary"
          gutterBottom
        >
          In Progress
        </Typography>
        {inprogress}
      </div>
      <div className="wide__column">
        <Typography
          className="wide__column__header"
          component="h3"
          color="primary"
          gutterBottom
        >
          Waiting
        </Typography>
        {completed}
      </div>
    </div>
  );
};

class LiveBookingsPanel extends React.Component {
  state = {
    showBookingNotification: false,
    newestBooking: {},
    isCompactScreen: false,
    bookingToRefund: null,
    showRefundConfirmation: false,
    showPreorderUpdateConfirmation: false,
    preorderToUpdate: null,
    initialBeepModalOpen: false,
    prepTab: 0,
    prepAreaLabel: 'general',
    isPrinting: false,
    showCompleteAllConfirmation: false,
    updatingAllBookings: false,
    updatingPreorder: false,
    preorderBookings: [],
    socketId: null,
  };

  printBooking = async bookingId => {
    this.setState({ isPrinting: true });

    try {
      const apiRequest = PrintBookingAPIRequest({ bookingId });
      await callAPI(apiRequest);

      this.props.showAlert(
        'Success',
        'We have sent a request to print this booking.'
      );
    } catch (e) {
      console.error(e);
      this.props.showAlert(
        'Failure',
        'Sorry, we could not print this booking.'
      );
    }

    this.setState({ isPrinting: false });
  };

  // Lifecycle

  componentWillUpdate(nextProps, nextState) {
    if (!nextProps.refundingBooking && this.props.refundingBooking) {
      if (nextProps.bookingRefunded && !this.props.bookingRefunded) {
        this.reloadAll();
        this.showBookingRefunded();
      } else {
        this.showBookingRefundedError();
      }
    }
  }

  componentWillMount() {
    Pusher.pusherClient.connection.bind('connected', () => {
      this.setState({ socketId: Pusher.pusherClient.connection.socket_id });
    });

    let label =
      localStorage.getItem('lastPrepAreaLabel') || this.state.prepAreaLabel;
    let tab = localStorage.getItem('lastPrepTab');

    if (!label) {
      label = this.state.prepAreaLabel;
    }

    if (!tab) {
      tab = 0;
    } else {
      tab = parseInt(tab, 10);
    }

    this.setState({
      prepTab: tab,
      prepAreaLabel: label,
    });

    window.addEventListener('resize', this.resize.bind(this));
    this.resize();

    this.setState({ initialBeepModalOpen: true });

    if (tab === 2) {
      this.fetchPreorders();
    } else {
      this.props.fetchLiveBookings(label);
    }
  }

  render() {
    const {
      preorderBookings,
      updatingPreorder,
      newestBooking,
      showBookingNotification,
      isCompactScreen,
      showRefundConfirmation,
      showCompleteAllConfirmation,
      updatingAllBookings,
      bookingToRefund,
      prepAreaLabel,
      prepTab,
    } = this.state;
    const {
      venue,
      liveBookings,
      user,
      refundBooking,
      fetchingLiveBookings,
      refundingBooking,
      showAlert,
    } = this.props;

    const newBookings = liveBookings.filter(
      b => b.live_prep_area_status[prepAreaLabel] === 'New'
    );
    const inProgressBookings = liveBookings.filter(
      b => b.live_prep_area_status[prepAreaLabel] === 'InProgress'
    );
    const completedBookings = liveBookings.filter(
      b => b.live_prep_area_status[prepAreaLabel] === 'Completed'
    );

    const preorderUpdate = async booking => {
      this.setState({
        updatingPreorder: true,
        showPreorderUpdateConfirmation: false,
      });

      const newPreorders = [...this.state.preorderBookings];
      const newPreorder = { ...booking };

      const apiRequest = EditLiveBookingAPIRequest({
        booking: newPreorder.id,
        newStatus: 'InProgress',
      });

      try {
        const bookingIndex = newPreorders.findIndex(
          b => b.id === newPreorder.id
        );
        newPreorders.splice(bookingIndex, 1);

        await callAPI(apiRequest);
        this.setState({ preorderBookings: newPreorders });
      } catch (e) {
        console.log(`Could not update this booking`);
      } finally {
        this.setState({ updatingPreorder: false });
      }
    };

    const bookingUpdate = async booking => {
      const newBookingsList = [...this.props.liveBookings];
      const newBooking = { ...booking };

      let newStatus = 'InProgress';

      switch (newBooking.live_prep_area_status[prepAreaLabel]) {
        case 'New':
          newStatus = 'InProgress';
          break;
        case 'InProgress':
          newStatus = 'Completed';
          break;
        case 'Completed':
          newStatus = 'Archived';
          break;
        default:
          newStatus = 'New';
          break;
      }

      newBooking.live_prep_area_status[prepAreaLabel] = newStatus;

      if (user.forename && user.surname) {
        const { forename, surname } = user;
        newBooking.live_assignee = `${forename} ${surname}`;
        newBooking.live_assignee_initials = `${forename[0].toUpperCase()}${surname[0].toUpperCase()}`;
      }

      const apiRequest = EditLiveBookingAPIRequest({
        booking: newBooking.id,
        newStatus,
        prepAreaLabel,
        socketId: this.state.socketId,
      });

      try {
        const bookingIndex = newBookingsList.findIndex(
          b => b.id === booking.id
        );
        newBookingsList.splice(bookingIndex, 1, newBooking);

        this.props.updateLocalLiveBookings(newBookingsList);
        await callAPI(apiRequest);
      } catch (e) {
        console.log(`Could not update this booking`);
      }
    };

    const hidePreorderUpdateConfirmation = () => {
      this.setState({ showPreorderUpdateConfirmation: false });
    };

    const triggerRefund = booking => {
      this.setState({
        bookingToRefund: booking,
        showRefundConfirmation: true,
      });
    };

    const hideRefundConfirmation = () => {
      this.setState({
        bookingToRefund: null,
        showRefundConfirmation: false,
      });
    };

    const changePrepArea = (event, val) => {
      const newPrepAreaLabel =
        val === 0 ? 'general' : val === 1 ? 'kitchen' : '';

      if (localStorage) {
        localStorage.setItem('lastPrepAreaLabel', newPrepAreaLabel);
        localStorage.setItem('lastPrepTab', val);
      }

      this.setState({
        prepTab: val,
        prepAreaLabel: newPrepAreaLabel,
      });

      this.reloadAll(newPrepAreaLabel);
    };

    const getSnackbarMessage = newestBooking => {
      const orderType = newestBooking.preorder ? 'Preorder' : 'Order';
      let extraInfo = 'for collection';

      if (newestBooking.service_type === 'table') {
        extraInfo = `at Table ${newestBooking.table}`;
      }

      if (newestBooking.service_type === 'dropoff') {
        extraInfo = `for Drop off at ${newestBooking.client_name}`;
      }

      return `New ${orderType} for ${newestBooking.name} ${extraInfo}`;
    };

    const commonOrderListProps = {
      onRefundBooking: triggerRefund,
      moveLiveBooking: bookingUpdate,
      prepArea: prepAreaLabel,
      printingEnabled: venue.printing_enabled,
      printBooking: this.printBooking,
      isPrinting: this.state.isPrinting,
    };

    const preorderList = (
      <PreorderList
        preorders={preorderBookings}
        movePreorder={booking =>
          this.setState({
            showPreorderUpdateConfirmation: true,
            preorderToUpdate: booking,
          })
        }
        {...commonOrderListProps}
      />
    );
    const newList = (
      <OrderList
        bookings={newBookings}
        prepArea={prepAreaLabel}
        {...commonOrderListProps}
      />
    );
    const progressList = (
      <OrderList
        bookings={inProgressBookings}
        prepArea={prepAreaLabel}
        {...commonOrderListProps}
      />
    );
    const completeList = (
      <OrderList
        bookings={completedBookings}
        prepArea={prepAreaLabel}
        {...commonOrderListProps}
      />
    );

    const isPreorderTab = prepTab === 2;

    const showCompleteAllButton =
      !isPreorderTab && liveBookings && liveBookings.length > 0;

    return (
      <React.Fragment>
        <audio className="audio-element">
          <source src={beep}></source>
        </audio>

        <Tabs
          className="tab__bar"
          centered
          variant={!isCompactScreen ? 'standard' : 'fullWidth'}
          value={prepTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={changePrepArea}
        >
          <Tab label="Front of House" />
          <Tab label="Kitchen" />
          {venue.accept_preorders && <Tab label="Preorders" />}
        </Tabs>
        <div className={!isCompactScreen ? 'live__bookings__container' : null}>
          {!isPreorderTab && (
            <React.Fragment>
              {isCompactScreen && (
                <CompactScreenContainer
                  neworders={newList}
                  inprogress={progressList}
                  completed={completeList}
                />
              )}
              {!isCompactScreen && (
                <WideScreenContainer
                  neworders={newList}
                  inprogress={progressList}
                  completed={completeList}
                />
              )}
            </React.Fragment>
          )}

          {isPreorderTab && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                alignItems: 'center',
              }}
            >
              {preorderList}
            </div>
          )}

          <Loader
            loading={
              fetchingLiveBookings ||
              refundingBooking ||
              updatingAllBookings ||
              updatingPreorder
            }
          />
        </div>

        {showCompleteAllButton && (
          <Fab
            variant="extended"
            aria-label="Complete All"
            classes={{ root: 'complete__all__fab' }}
            onClick={() => this.setState({ showCompleteAllConfirmation: true })}
          >
            <Icon style={{ marginRight: 8 }}>check_circle_outline</Icon>
            Complete All Orders
          </Fab>
        )}

        <BoopPusherNewBooking
          venue={venue._id}
          onUpdate={this.receiveNewBookingData}
        />
        <BoopPusherUpdatedBooking
          venue={venue._id}
          onUpdate={this.bookingUpdatedData}
        />

        <NotifySnackbar
          message={`${getSnackbarMessage(newestBooking)}`}
          open={showBookingNotification}
          onClose={() => this.setState({ showBookingNotification: false })}
        />

        <ConfirmationDialog
          open={showRefundConfirmation}
          confirmationTitle="Refund Booking"
          onClose={() => hideRefundConfirmation()}
          showInput={true}
          inputLabel={`Refund Amount (${accentForCurrency(venue.currency)})`}
          confirmationDescription="You are about to refund this booking. How much would you like to refund?"
          inputPlaceholder="e.g 1.99"
          inputDefaultValue={
            bookingToRefund
              ? (
                  (bookingToRefund.total - bookingToRefund.fee_paid) /
                  multiplyValueForCurrency(venue.currency)
                ).toFixed(2)
              : ''
          }
          onConfirm={refundAmountString => {
            const amountNumber = parseFloat(refundAmountString);

            if (isNaN(amountNumber)) {
              showAlert("That's not a valid amount. Please try again.");
              return;
            }

            if (
              amountNumber * multiplyValueForCurrency(venue.currency) >
                bookingToRefund.total - bookingToRefund.fee_paid ||
              amountNumber === 0
            ) {
              showAlert(
                "You didn't enter a valid refund amount. It must greater than 0 and less than the total."
              );
              return;
            }

            const rValue = Math.round(
              amountNumber * multiplyValueForCurrency(venue.currency)
            );
            refundBooking(rValue);
            this.setState({ showRefundConfirmation: false });
          }}
        />

        <ConfirmationDialog
          open={showCompleteAllConfirmation}
          confirmationTitle="Complete All Bookings"
          confirmationDescription={`You are about to complete ALL orders at once, including both front of house and kitchen. If you accept collections, text messages won't be sent using this approach. Are you sure you want to do this?`}
          onConfirm={async () => {
            this.setState({
              updatingAllBookings: true,
              showCompleteAllConfirmation: false,
            });

            const apiRequest = EditLiveBookingAPIRequest({
              allBookings: true,
              newStatus: 'Archived',
              prepAreaLabel,
            });

            try {
              await callAPI(apiRequest);
              this.reloadAll(prepAreaLabel);

              this.props.showAlert(
                'Bookings Complete',
                'All bookings have been completed.'
              );
            } catch (e) {
              this.props.showAlert(
                'Something went wrong',
                'We could not update all your bookings'
              );
            }

            this.setState({ updatingAllBookings: false });
          }}
          onClose={() => {
            this.setState({ showCompleteAllConfirmation: false });
          }}
        />

        <ConfirmationDialog
          open={this.state.showPreorderUpdateConfirmation}
          confirmationTitle="Update Preorder"
          onClose={() => hidePreorderUpdateConfirmation()}
          showInput={false}
          confirmationDescription="You are about to start a preorder. Preorders usually automatically move to 'New' 15 minutes before collection time. This action will move all the order into 'In Progress' immediately. Are you sure you wish to do this?"
          onConfirm={() => {
            preorderUpdate(this.state.preorderToUpdate);
          }}
        />

        <BoopAlert
          open={this.state.initialBeepModalOpen}
          onClose={() => this.setState({ initialBeepModalOpen: false })}
        />
      </React.Fragment>
    );
  }

  // Utility

  showBookingRefunded = () => {
    this.props.showAlert('Booking Refunded', 'Successfully refunded booking.');
  };

  showBookingRefundedError = () => {
    this.props.showAlert(
      'Could not refund booking',
      'Failed to refund booking. Please try again later.'
    );
  };

  resize() {
    this.setState({ isCompactScreen: window.innerWidth <= 900 });
  }

  reloadAll = prepArea => {
    const { prepAreaLabel } = this.state;

    this.props.updateLocalLiveBookings([]);

    if (prepArea === '') {
      this.fetchPreorders();
    } else {
      this.props.fetchLiveBookings(prepArea || prepAreaLabel);
    }
  };

  fetchPreorders = async () => {
    const apiRequest = GetBookingsAPIRequest({
      live: true,
      prepAreaLabel: '',
      preorderOnly: true,
    });

    try {
      const preorderBookings = await callAPI(apiRequest);
      this.setState({ preorderBookings: preorderBookings.bookings });
    } catch (e) {
      console.error('Failed to get Preordered Bookings', e);
    }
  };

  // Pusher

  receiveNewBookingData = booking => {
    window.Intercom('trackEvent', 'taken-payment');

    if (booking.preorder) {
      // Preorder just made
      const newPreorders = [...this.state.preorderBookings];

      newPreorders.push(booking);
      newPreorders.sort((a, b) =>
        a.collection_time > b.collection_time
          ? 1
          : a.collection_time < b.collection_time
          ? -1
          : 0
      );

      this.setState({ preorderBookings: newPreorders });
    } else if (booking.collection_time) {
      // Remove from current preorders list
      const newPreorders = [...this.state.preorderBookings];
      let indexToRemove = -1;

      for (let index = 0; index < newPreorders.length; index++) {
        const po = newPreorders[index];
        if (po.id === booking.id) {
          indexToRemove = index;
          break;
        }
      }

      if (indexToRemove !== -1) {
        newPreorders.splice(indexToRemove, 1);
      }

      this.setState({ preorderBookings: newPreorders, newestBooking: booking });
    }

    if (!booking.preorder) {
      const newBookingsList = [...this.props.liveBookings];
      const newBooking = this.createSplitBooking(booking);

      newBookingsList.push(newBooking);
      this.props.updateLocalLiveBookings(newBookingsList);

      this.setState({ showBookingNotification: true, newestBooking: booking });
    }
  };

  bookingUpdatedData = booking => {
    const bookingList = [...this.props.liveBookings];

    const newBooking = this.createSplitBooking(booking);
    const existingIndex = bookingList.findIndex(v => v.id === booking.id);

    bookingList.splice(existingIndex, 1, newBooking);
    this.props.updateLocalLiveBookings(bookingList);
  };

  createSplitBooking = booking => {
    const newBooking = { ...booking };
    newBooking.order_items = [];

    booking.order_items.forEach(oi => {
      if (oi.label === this.state.prepAreaLabel) {
        newBooking.order_items.push(oi);
      }
    });

    return newBooking;
  };
}

const BoopAlert = ({ open, onClose }) => {
  return (
    <AlertDialog
      alertTitle={'Order & Pay'}
      alertDescription={
        'We must request to use audio to notify you of new orders, please click okay to proceed.'
      }
      open={open}
      onClose={() => {
        const audioEl = document.getElementsByClassName('audio-element')[0];
        audioEl.volume = 0.0;
        audioEl.play();
        onClose();
      }}
    />
  );
};

const BoopPusherNewBooking = ({ venue, onUpdate }) => {
  return (
    <Pusher
      channel={`live-bookings-${venue}`}
      event="new-live-booking"
      onUpdate={data => {
        const audioEl = document.getElementsByClassName('audio-element')[0];
        audioEl.volume = 1.0;
        audioEl.play();
        onUpdate(data);
      }}
    />
  );
};

const BoopPusherUpdatedBooking = ({ venue, onUpdate }) => {
  return (
    <Pusher
      channel={`live-bookings-${venue}`}
      event="booking-updated"
      onUpdate={data => {
        // const audioEl = document.getElementsByClassName("audio-element")[0];
        // audioEl.volume = 0.05;
        // audioEl.play()
        onUpdate(data);
      }}
    />
  );
};

const mapStateToProps = state => ({
  fetchingLiveBookings: state.booking.fetchingLiveBookings,
  venue: state.venue,
  user: state.authentication.user,
  liveBookings: state.booking.liveBookings || [],
  bookingRefunded: state.booking.bookingRefunded,
  refundingBooking: state.booking.refundingBooking,
});

const mapDispatchToProps = dispatch => ({
  showAlert: (title, desc) => dispatch(showAlert(title, desc)),
  fetchLiveBookings: prepAreaLabel =>
    dispatch(fetchLiveBookings(prepAreaLabel)),
  moveLiveBooking: (booking, newStatus, prepAreaLabel) =>
    dispatch(moveLiveBooking(booking, newStatus, prepAreaLabel)),
  refundBooking: (id, amountPence) => dispatch(refundBooking(id, amountPence)),
  updateLocalLiveBookings: newBookingsList =>
    dispatch(updateLocalLiveBookings(newBookingsList)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LiveBookingsPanel);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/LiveBookings/index.jsx